import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTargetDropdownComponent} from "./int-target-dropdown.component";
import {IntPortalSlotModule} from "../../../modules";
import {IntDropdownAreaModule} from "../int-dropdown-area";
import {IntInsertAfterViewInitModule} from "../../../directives";

@NgModule({
  imports: [
    CommonModule,
    IntDropdownAreaModule,
    IntPortalSlotModule,
    IntInsertAfterViewInitModule
  ],
  declarations: [
    IntTargetDropdownComponent
  ],
  exports: [
    IntTargetDropdownComponent
  ]
})
export class IntTargetDropdownModule {}
